var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"contenedor-principal"},[_c('AsideMenu'),_c('section',{staticClass:"seccion-principal",class:{'seccion-principal--barra-avance-open' : !_vm.menuState}},[_c('router-view')],1)],1),_c('BarraAvance'),_c('Accesibilidad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }